/* eslint-disable max-len */
import { createIcon } from '@chakra-ui/icon';
import * as React from 'react';
export var CaretLeftIcon = createIcon({
  displayName: 'CaretLeftIcon',
  viewBox: '0 0 10 24',
  d: 'M1.5 12l-.707-.707a1 1 0 000 1.414L1.5 12zm7.707-6.293a1 1 0 00-1.414-1.414l1.414 1.414zm-1.414 14a1 1 0 001.414-1.414l-1.414 1.414zm-5.586-7l7-7-1.414-1.414-7 7 1.414 1.414zm-1.414 0l7 7 1.414-1.414-7-7-1.414 1.414z'
});
export var CaretRightIcon = createIcon({
  displayName: 'CaretRightIcon',
  viewBox: '0 0 10 24',
  d: 'M8.5 12l.707.707a1 1 0 000-1.414L8.5 12zM.793 18.293a1 1 0 101.414 1.414L.793 18.293zm1.414-14A1 1 0 00.793 5.707l1.414-1.414zm5.586 7l-7 7 1.414 1.414 7-7-1.414-1.414zm1.414 0l-7-7L.793 5.707l7 7 1.414-1.414z'
});
export var CalendarIcon = createIcon({
  displayName: 'CalendarIcon',
  path: /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8 1a1 1 0 00-2 0v1H4a3 3 0 00-3 3v14a3 3 0 003 3h16a3 3 0 003-3V5a3 3 0 00-3-3h-2V1a1 1 0 10-2 0v1H8V1zm8 4V4H8v1a1 1 0 01-2 0V4H4a1 1 0 00-1 1v3h18V5a1 1 0 00-1-1h-2v1a1 1 0 11-2 0zm5 5H3v9a1 1 0 001 1h16a1 1 0 001-1v-9z",
    fill: "currentColor",
    fillRule: "evenodd"
  })
});
export var CaretDownIcon = createIcon({
  displayName: 'CaretDownIcon',
  viewBox: '0 0 14 24',
  d: 'M7.707 15.293a1 1 0 01-1.414 0l-4.586-4.586C1.077 10.077 1.523 9 2.414 9h9.172c.89 0 1.337 1.077.707 1.707l-4.586 4.586z'
});
export var CaretUpIcon = createIcon({
  displayName: 'CaretUpIcon',
  viewBox: '0 0 14 24',
  d: 'M6.293 8.707a1 1 0 011.414 0l4.586 4.586c.63.63.184 1.707-.707 1.707H2.414c-.89 0-1.337-1.077-.707-1.707l4.586-4.586z'
});
export var CloseIcon = createIcon({
  displayName: 'CaretUpIcon',
  viewBox: '0 0 24 24',
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5C10.7958 10.7958 17.5 17.5 17.5 17.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.5C13.2042 10.7958 6.5 17.5 6.5 17.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2"
  }))
});
export var ArrowRightIcon = createIcon({
  displayName: 'ArrowRightIcon',
  viewBox: '0 0 14 12',
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M7.70711 1.05025L12.6569 6L7.70711 10.9497",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2426 6H1.34314",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }))
});
export var PipeIcon = createIcon({
  displayName: 'PipeIcon',
  viewBox: '0 0 1 48',
  path: /*#__PURE__*/React.createElement("rect", {
    fill: "transparent",
    height: "48",
    width: "1"
  })
});
//# sourceMappingURL=icons.js.map